import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import '../TourPage/Style/TourPage.css'
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Person } from "bootstrap-icons/icons/person.svg";
import { ReactComponent as IconDoorClosedFill } from "bootstrap-icons/icons/door-closed.svg";
import { ReactComponent as House } from "bootstrap-icons/icons/house.svg";
import config from '../../config';
import { connect } from 'react-redux';
import { setCurrency } from './CurrencyRedux/currencyAction';
import { toast } from "react-toastify";  // Importing toast

const SearchableSelect = ({ id, containerRef, options = [], placeholder, onSelect, openDropdown, setOpenDropdown, resetSignal }, ref) => {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setSearchTerm("");   // when parent asks, clear input
  }, [resetSignal]);

  const isOpen = openDropdown === id;

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const handleSelect = (opt) => {
    setSearchTerm(opt.label);
    onSelect(opt);
    // setOpen(false);
    setOpenDropdown(null);
  };

  return (
    <div ref={containerRef} className="searchable-select" style={{ position: "relative" }}>
      <input
        type="text"
        value={searchTerm}
        placeholder={placeholder}
        onChange={(e) => setSearchTerm(e.target.value)}
        // onClick={() => setOpen(true)}
        onClick={() => setOpenDropdown(id)}
      // style={{
      //   // width: "200px",
      //   // padding: "2px 2px",
      //   // fontSize: "12px",
      //   boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
      //   borderRadius: "20px",
      //   outline: "none",
      // }}
      />

      {isOpen && (
        <ul
          className="options"
          style={{
            position: "absolute",
            top: "100%",          // PUSH DROPDOWN LOWER
            background: "#fff",
            border: "1px solid rgb(190 78 41 / 53%)",
            borderRadius: "6px",
            maxHeight: "100px",   // SMALLER HEIGHT
            overflowY: "auto",
            fontSize: "12px",
            // padding: "2px 0",
            // marginTop: "2px",
            zIndex: 99,
            // maxWidth:"100px",
            // left:"-12px",
            width: "110px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
          }}
        >
          {filteredOptions.length === 0 ? (
            <li
              style={{
                padding: "4px 8px",
                fontSize: "12px",
                color: "#888"
              }}
            >
              No results
            </li>
          ) : (
            filteredOptions.map((opt, i) => (
              <li
                key={i}
                onClick={() => handleSelect(opt)}
                style={{
                  padding: "6px 10px",
                  fontSize: "14px",     // SMALLER TEXT
                  cursor: "pointer",
                  transition: "0.2s",
                }}
                onMouseEnter={(e) => (e.target.style.background = "#f2592822")}
                onMouseLeave={(e) => (e.target.style.background = "transparent")}
              >
                {opt.label}
              </li>
            ))
          )}
        </ul>
      )}

    </div>
  );
};

const InnerHeader = ({ selectedCurrency, setCurrency }) => {
  const search = () => {

  }
  const navigate = useNavigate()
  const [first_name, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [searchCountry, setSearchCountry] = useState('');
  const [userType, setUserType] = useState(null);
  const [userDiscount, setUserDiscount] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState('');

  const [openDropdown, setOpenDropdown] = useState(null);

  const [destinations, setDestinations] = useState([]);

  const [countryId, setCountryId] = useState("");
  const [stateName, setStateName] = useState("");
  const [destinationName, setDestinationName] = useState("");

  const [countriesList, setCountriesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [destinationsList, setDestinationsList] = useState([]);

  const countryRef = useRef(null);
  const stateRef = useRef(null);
  const destinationRef = useRef(null);

  const [resetCounter, setResetCounter] = useState(0);

  const [searchQuery, setSearchQuery] = useState("");

  let cartdata = localStorage.getItem("cartdata");
  let cartData = cartdata ? JSON.parse(cartdata) : [];

  const handleCountrySearch = (country) => {
    setSearchCountry(country);
  };
  const handleCurrencyChange = (currency) => {
    // Remove only cartdata from localStorage
    localStorage.removeItem('cartdata');
    setCurrency(currency);
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
  };

  const handlePersonSelect = (selectedPerson) => {
    const selectedText = `${selectedPerson} Travellers`;
    // Do something with the selectedText, such as displaying it or storing it in a state variable.
  };


  const handleSearchClick = (e) => {
    e.preventDefault();

    // console.log("countryId:", countryId);
    // console.log("stateName:", stateName);
    // console.log("destinationName:", destinationName);


    if (!countryId || !stateName || !destinationName) {
      alert("Please select country, state and destination");
      return;
    }

    const encodedCountry = encodeURIComponent(
      countryId.toString().replace(/\s+/g, "-").toLowerCase()
    );

    navigate(`/tour/${encodedCountry}?country=${countryId}&state=${stateName}&destination=${destinationName}`);

    // RESET ALL FIELDS AFTER SEARCH
    setCountryId("");
    setStateName("");
    setDestinationName("");
    setStatesList([]);
    setDestinationsList([]);
    setResetCounter(prev => prev + 1);

  };

  useEffect(() => {
    function handleClickOutside(e) {
      if (
        countryRef.current &&
        !countryRef.current.contains(e.target) &&
        stateRef.current &&
        !stateRef.current.contains(e.target) &&
        destinationRef.current &&
        !destinationRef.current.contains(e.target)
      ) {
        setOpenDropdown(null);
      }
    }

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);


  // useEffect(() => {
  //   const fetchDestinations = async () => {
  //     try {
  //       const response = await fetch(`${config.baseUrl}/destanition/list`);
  //       const data = await response.json();
  //       if (data.status === 'success') {
  //         setDestinations(data.data);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching destinations:', error);
  //     }
  //   };

  //   fetchDestinations();
  // }, []);


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetch(`${config.baseUrl}/welcome`, {
        headers: {
          Authorization: `Bearer ${token}`
        }

      })

        .then(response => response.json())

        .then(data => {

          setUserName(data.data.first_name);
          setEmail(data.data.email);
          setIsLoggedIn(true);
        })

        .catch(error => {
          console.error("Error fetching user data:", error);
        });
    }
  }, []);

  useEffect(() => {
    fetch(`${config.baseUrl}/destinationnew-countery-list`)
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setCountriesList(data.data);
        }
      });
  }, []);


  useEffect(() => {
    if (!countryId) return;

    fetch(`${config.baseUrl}/destinationnew-state-list/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country_name: countryId })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setStatesList(data.data);
        }
      });

    setStateName("");
    setDestinationsList([]);
    setDestinationName("");
  }, [countryId]);



  useEffect(() => {
    if (!stateName) return;

    fetch(`${config.baseUrl}/destinationnew-name-list/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ country_name: countryId, state: stateName })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setDestinationsList(data.data);
        }
      });

    setDestinationName("");
  }, [stateName]);


  const handleLogout = () => {
    fetch(`${config.baseUrl}/logout`, {
      method: 'POST',
    })
      .then(() => {
        localStorage.removeItem('token');
        // localStorage.removeItem('first_name');
        setIsLoggedIn(false);
      })
      .catch(error => {
        console.error('Logout failed', error);
      });
  };

  // When user selects a country
  const handleCountrySelect = (opt) => {
    setCountryId(opt.value);   // country id
    setStateName("");          // reset state
    setDestinationName("");    // reset destination
    setStatesList([]);         // clear state list
    setDestinationsList([]);   // clear destination list
  };

  // When user selects a state
  const handleStateSelect = (opt) => {
    setStateName(opt.label);      // state name
    setDestinationName("");       // reset destination
    setDestinationsList([]);      // clear old destination list
  };


  const handleSearchClickone = async () => {
    if (!searchQuery || searchQuery.trim() === "") {
      toast.error("Please enter a search term");
      return;
    }

    // console.log("Search Clicked!");
    // console.log("Search Query:", searchQuery);

    try {
      const requestBody = {
        search: searchQuery.trim()
      };

      // console.log("Sending request to API:", requestBody);

      const response = await fetch(`${config.baseUrl}/search`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      // console.log("API Response Status:", response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      // console.log("API Response Data:", data);

      if (data.status === "success" && data.length > 0) {
        const encodedQuery = encodeURIComponent(searchQuery);
        navigate(`/tour/${encodedQuery}?search=${encodedQuery}`);
      } else {
        toast.info("No tours found matching your search");
      }

    } catch (error) {
      console.error("Error fetching search results:", error);
      toast.error("Failed to fetch search results. Please try again!");
    }
  };





  return (
    <div>
      <header className="innerpageHeader"> {/* Use className instead of class */}
        <div className="innerHeader"> {/* Use className instead of class */}
          <div className="container"> {/* Use className instead of class */}
            <div className="innerHeaderWrapper"> {/* Use className instead of class */}
              <div className="HeaderLHS"> {/* Use className instead of class */}
                <div className="Logo"> {/* Use className instead of class */}
                  <Link to="/">
                    <img src={"https://res.cloudinary.com/dqslvlm0d/image/upload/v1701321722/innerlogo_yezfc1.svg"} alt="" />
                  </Link>
                </div>


                <div className="HeaderSearch"> {/* Use className instead of class */}


                  {/* <form className="form"> 
                    <SearchableSelect
                      options={destinations.map((destination) => destination.destination_name)}
                      placeholder="Search"
                      onSelect={handleCountrySearch}
                    />
                    <button onClick={(e) => handleSearchClick(e)} className="SearchIcon"></button>
                  </form> */}

                  {/* <form className="form"> */}

                  {/* <SearchableSelect
                      options={countriesList.map(c => ({
                        label: c.name,
                        value: c.id
                      }))}
                      placeholder="Country.."
                      onSelect={handleCountrySelect}
                    />

                    <SearchableSelect
                      options={statesList.map(s => ({
                        label: s.name,
                        value: s.name
                      }))}
                      placeholder="State.."
                      onSelect={handleStateSelect}
                    />

                    <SearchableSelect
                      options={destinationsList.map(d => ({
                        label: d.destination_name,
                        value: d.destination_name
                      }))}
                      placeholder="Destination.."
                      onSelect={(opt) => setDestinationName(opt.label)}
                    /> */}

                  {/* 
                    <SearchableSelect
                      id="country"
                      ref={countryRef}
                      containerRef={countryRef}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                      resetSignal={resetCounter}
                      options={countriesList.map(c => ({ label: c.name, value: c.id }))}
                      placeholder="Country.."
                      onSelect={handleCountrySelect}
                    />


                    <SearchableSelect
                      id="state"
                      ref={stateRef}
                      containerRef={stateRef}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                      resetSignal={resetCounter}
                      options={statesList.map(s => ({ label: s.name, value: s.name }))}
                      placeholder="State.."
                      onSelect={handleStateSelect}
                    />

                    <SearchableSelect
                      id="destination"
                      ref={destinationRef}
                      containerRef={destinationRef}
                      openDropdown={openDropdown}
                      setOpenDropdown={setOpenDropdown}
                      resetSignal={resetCounter}
                      options={destinationsList.map(d => ({ label: d.destination_name, value: d.destination_name }))}
                      placeholder="Destination.."
                      onSelect={(opt) => setDestinationName(opt.label)}
                    /> */}



                  {/* Search Button */}
                  {/* <button onClick={handleSearchClick} className="SearchIcon"></button>
                  </form> */}

                  <form className="form" onSubmit={(e) => {
                    e.preventDefault();
                    handleSearchClickone();
                  }}>

                    <div className="searchRow">
                      <div className="searchItem">
                        <input
                          type="text"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          placeholder="Search for tours"
                          className="searchInput"
                        />
                      </div>
                    </div>

                    <div className="SearchBtn">
                      <button
                        type="submit"
                        className="searchIcon"
                      ></button>
                    </div>
                  </form>



                </div>
              </div>
              {/* HeaderLHS */}
              <div className="HeaderRHS"> {/* Use className instead of class */}
                <div className="Headerdropdownmenu"> {/* Use className instead of class */}
                  {/*}  <div className="dropdown">
                    <Link to="" className="btn dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"> ENG </Link>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <li>
                        <Link to="" className="dropdown-item" href="#">Spanish</Link>
                      </li>
                      <li>
                        <Link to="" className="dropdown-item" href="#">French</Link>
                      </li>
                      <li>
                        <Link to="" className="dropdown-item" href="#">German</Link>
                      </li>
                    </ul>
  </div>*/}


                  <div className="dropdown">
                    <Link
                      className="btn dropdown-toggle"
                      to="/"
                      role="button"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {selectedCurrency}
                    </Link>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleCurrencyChange('AED')}
                        >
                          AED
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => handleCurrencyChange('USD')}
                        >
                          USD
                        </button>
                      </li>
                    </ul>
                  </div>

                </div>

                {/* Headerdropdownmenu */}
                <div className="addtocart"> {/* Use className instead of class */}
                  <Link to="/cart" className="cart Cartparenticon">
                    {/* Cart Icon */}
                    <span className="badgeCart" style={{ 'color': 'black' }}>{cartData.length}</span>
                  </Link>
                  {
                    isLoggedIn ? (
                      <Link to="/wishlist" className="wishlist"></Link>
                    ) : (
                      <Link to="/login" className="wishlist"></Link>
                    )
                  }


                  <div className="dropdown userIcon">
                    <Link className="btn userIconTag dropdown-toggle" to="/" role="button" id="userIcon" data-bs-toggle="dropdown" aria-expanded="false"></Link>
                    <ul className="dropdown-menu" aria-labelledby="userIcon">

                      {isLoggedIn ? (
                        <div>
                          <Link to="/user-dashboard" className="dropdown-item">
                            <div >
                              <Person className="text-danger" />
                              <span className="userName" style={{ color: "black" }}>{first_name}</span>
                            </div>
                          </Link>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <Link to="/booking" className="dropdown-item">
                              <House className="text-danger" /> Bookings
                            </Link>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <Link className="dropdown-item" onClick={handleLogout}>
                              <IconDoorClosedFill className="text-danger" /> Logout
                            </Link>
                          </li>
                        </div>

                      ) : (
                        <Link to="/login" className="dropdown-item">Login/SignUp</Link>
                      )}


                    </ul>
                  </div>
                </div>
                {/* addtocart */}
              </div>
              {/* HeaderRHS */}
            </div>
            {/* innerHeaderWrapper */}
          </div>
          {/* container */}
        </div>
        {/* innerHeader */}
      </header>
    </div>
  );
  function getUserPrice(tour) {
    let price = 0;

    if (userType === 2) {
      // Agent user type
      price =
        selectedCurrency === "AED"
          ? tour.tour_price_aed - (tour.tour_price_aed * userDiscount) / 100
          : tour.tour_price_usd - (tour.tour_price_usd * userDiscount) / 100;
    } else if (userType === 3) {
      // Normal user type
      price = selectedCurrency === "AED" ? tour.tour_price_aed : tour.tour_price_usd;
    } else {
      // Default case (handle other user types if needed)
      price = selectedCurrency === "AED" ? tour.tour_price_aed : tour.tour_price_usd;
    }

    // Remove decimal part
    return Math.floor(price);
  }
};
const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrency: (currency) => dispatch(setCurrency(currency)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InnerHeader);
